import { handleActions } from 'redux-actions';
import { getDateForPostShare } from '../services/utils';

const INITIAL_STATE = {
  applicationMessages: null,
  comingSoon: {
    isSendingMessage: false,
    messageSent: false,
  },
  contentfulPage: {
    content: '',
    loading: false,
    title: '',
  },
  dialogMessage: {
    message: '',
    title: '',
    visible: false,
  },
  generalData: null,
  globalContactUsModalVisible: false,
  landing: {
    sideImage: '',
  },
  languages: {
    data: [],
    loading: false,
    switching: false,
  },
  logoutModalVisible: false,
  sharePost: {
    isLoading: false,
    postAuthorName: '',
    postAuthorPicPath: null,
    postContents: null,
    postDate: null,
    postId: null,
    postPhotoPath: null,
  },
  showGenericError: false,
  zipCodeDetails: {
    data: null,
    error: false,
    loadingZipCodeDetails: false,
  },
};

export default handleActions({
  APPLICATION_MESSAGES_LOADED: (state, { payload }) => ({
    ...state,
    applicationMessages: payload,
  }),
  CONTENTFUL_PAGE_LOADED: (state, { payload }) => ({
    ...state,
    contentfulPage: {
      content: payload.description?.replace(/&#160;/g, ' ') || '',
      loading: false,
      title: payload.title || '',
    },
  }),
  DIALOG_MESSAGE_UPDATED: (state, { payload }) => ({
    ...state,
    dialogMessage: {
      message: payload.message || '',
      title: payload.title || '',
      visible: payload.visible,
    },
  }),
  DO_LOGOUT: () => ({ ...INITIAL_STATE }),
  GENERAL_DATA_LOADED: (state, { payload }) => ({
    ...state,
    generalData: payload,
  }),
  GET_CONTENTFUL_PAGE: (state) => ({
    ...state,
    contentfulPage: {
      ...state.contentfulPage,
      loading: true,
    },
  }),
  GET_GENERAL_DATA: (state) => ({
    ...state,
    generalData: null,
  }),
  GET_LANGUAGES: (state) => ({
    ...state,
    languages: {
      ...state.languages,
      data: [],
      loading: true,
    },
  }),
  GET_SHARE_POST_DATA: (state) => ({
    ...state,
    sharePost: {
      ...state.sharePost,
      isLoading: true,
    },
  }),
  GET_SHARE_POST_DATA_FAILED: (state) => ({
    ...state,
    sharePost: {
      ...state.sharePost,
      isLoading: false,
    },
  }),
  GET_SHARE_POST_DATA_SUCCESS: (state, { payload }) => ({
    ...state,
    sharePost: {
      ...state.sharePost,
      isLoading: false,
      postAuthorName: payload.PostAuthorName,
      postAuthorPicPath: payload.PostAuthorPicturePath,
      postContents: payload.PostContents,
      postDate: getDateForPostShare(payload.PostDate),
      postId: payload.PostId,
      postPhotoPath: payload.PostPhotoPath,
    },
  }),
  GLOBAL_CONTACT_US_MODAL_TOGGLED: (state) => ({
    ...state,
    globalContactUsModalVisible: !state.globalContactUsModalVisible,
  }),
  LANGUAGES_LOADED_FAILED: (state) => ({
    ...state,
    languages: {
      ...state.languages,
      data: [],
      loading: false,
    },
  }),
  LANGUAGES_LOADED_SUCCESS: (state, { payload }) => ({
    ...state,
    languages: {
      ...state.languages,
      data: payload,
      loading: false,
    },
  }),
  LINK_MESSAGE_SENT: (state, { payload }) => ({
    ...state,
    comingSoon: {
      ...state.comingSoon,
      isSendingMessage: false,
      messageSent: payload,
    },
  }),
  LOGOUT_MODAL_VISIBLE_CHANGED: (state, { payload }) => ({
    ...state,
    logoutModalVisible: payload,
  }),
  PUBLIC_SIDE_IMAGE_LOADED: (state, { payload }) => ({
    ...state,
    landing: {
      ...state.landing,
      sideImage: payload,
    },
  }),
  SEND_LINK_MESSAGE: (state) => ({
    ...state,
    comingSoon: {
      ...state.comingSoon,
      isSendingMessage: true,
      messageSent: false,
    },
  }),
  SEND_MESSAGE_RESTARTED: (state) => ({
    ...state,
    comingSoon: {
      ...state.comingSoon,
      isSendingMessage: false,
      messageSent: false,
    },
  }),
  SHOW_GENERIC_ERROR: (state, { payload }) => ({
    ...state,
    showGenericError: payload,
  }),
  SWITCHING_LANGUAGE_CHANGED: (state, { payload }) => ({
    ...state,
    languages: {
      ...state.languages,
      switching: payload,
    },
  }),
  ZIP_CODE_DETAILS_LOADED: (state, { payload }) => ({
    ...state,
    zipCodeDetails: {
      data: payload,
      error: false,
      loadingZipCodeDetails: false,
    },
  }),
}, INITIAL_STATE);
